import { useMutation } from '@tanstack/react-query'

import { sendMFAEmailCode } from '../services/send-MFA-email-code.service'

export function useSendMFAEmailCode() {
  return useMutation({
    mutationFn: sendMFAEmailCode,
  })
}
